"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.DateSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CenterStack = _interopRequireDefault(require("../../../CenterStack/index.js"));
var _HorizontalStack = _interopRequireDefault(require("../../../HorizontalStack/index.js"));
var _VerticalStack = _interopRequireDefault(require("../../../VerticalStack/index.js"));
var _DatePickerHorizontalStack = require("./DatePickerHorizontalStack.js");
var _images = require("../../../DatePickerInput/assets/images.js");
var _SvgIcon3 = _interopRequireDefault(require("../../../SvgIcon/index.js"));
var _interface = require("../../interface.js");
var _StyledMonthSelector = require("./StyledMonthSelector.js");
var _themeProvider = require("../../../../../theme/themeProvider/index.js");
var _jsxRuntime = require("react/jsx-runtime");
var _SvgIcon, _SvgIcon2;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DateSelector = props => {
  const {
    prevMonthButtonView,
    monthYearColor,
    monthNames,
    nextMonthButtonView,
    weekdayNames,
    weekdaysColor,
    daysColor,
    disabledDaysColor,
    mode,
    selectedDate,
    onDateChange,
    onChangeDatesHande,
    onChangeStartEndDateHandle,
    maxDate,
    minDate,
    startDate,
    selectedDates,
    monthOffset,
    endDate,
    currentYearMonth,
    setCurrentYearMonth,
    setCurrentSelector,
    borderRadius,
    calenderBoxShadow,
    calenderBorderWidth,
    calenderBorderStyle,
    calenderBorderColor,
    monthYearFontFamily,
    monthYearFontStyle,
    monthYearFontWeight = '700',
    monthYearFontSize = 14,
    monthYearTransformation,
    monthYearDecoration,
    hoverMonthYearTextColor,
    hoverMonthYearBgColor,
    weekFontFamily,
    weekFontStyle,
    weekFontWeight,
    weekFontSize,
    weekTransformation,
    weekDecoration,
    hoverWeekTextColor,
    hoverWeekBgColor,
    weekLineHeight,
    dateWeekHeight,
    dateWeekWidth,
    dateWeekMargin,
    dateBgColor,
    hoverDateBgColor,
    dateBorderRadius,
    dateBorderWidth,
    dateBorderStyle,
    dateBorderColor,
    dateBoxShadow,
    dateFontFamily,
    dateFontStyle,
    dateFontWeight,
    dateFontSize,
    dateTransformation,
    dateDecoration,
    hoverDateTextColor,
    dateLineHeight,
    disabledDateBgColor,
    disabledDateBorderRadius,
    disabledDateBorderWidth,
    disabledDateBorderStyle,
    disabledDateBorderColor,
    disabledDateBoxShadow,
    disabledDateFontFamily,
    disabledDateFontStyle,
    disabledDateFontWeight,
    disabledDateFontSize,
    disabledDateTransformation,
    disabledDateDecoration,
    disabledDateTextColor
  } = props;
  const theme = (0, _themeProvider.useTheme)();
  const [selDate, setSelectedDate] = (0, _react.useState)(selectedDate);
  const [selDates, setSelectedDates] = (0, _react.useState)(selectedDates);
  const [sDate, setStartDate] = (0, _react.useState)(startDate);
  const [eDate, setEndDate] = (0, _react.useState)(endDate);
  const handleSetDate = date => {
    setEndDate(date);
  };
  const daysPerWeek = 7;
  const lastMonthDay = new Date(currentYearMonth.getFullYear(), currentYearMonth.getMonth() + 1, 0).getDate();
  let firstDayOfWeek = new Date(currentYearMonth.getFullYear(), currentYearMonth.getMonth(), 1).getDay();
  firstDayOfWeek = firstDayOfWeek == 0 ? 7 : firstDayOfWeek;
  const calenderRows = ~~((lastMonthDay + firstDayOfWeek - 1) / daysPerWeek) + ((lastMonthDay + firstDayOfWeek - 1) % daysPerWeek > 0 ? 1 : 0);
  const days = [];
  const prevMonth = new Date(currentYearMonth.getFullYear(), currentYearMonth.getMonth() - 1, 1);
  const lastPrevMonthDay = new Date(prevMonth.getFullYear(), prevMonth.getMonth() + 1, 0).getDate();
  const nextMonth = new Date(currentYearMonth.getFullYear(), currentYearMonth.getMonth() + 1, 1);
  let i;
  let day;
  for (let r = 0; r < calenderRows; r++) {
    for (let cell = 1; cell <= daysPerWeek; cell++) {
      i = r * daysPerWeek + cell + 1;
      if (firstDayOfWeek > i) {
        day = lastPrevMonthDay - (firstDayOfWeek - i);
        days.push(new Date(prevMonth.getFullYear(), prevMonth.getMonth(), day));
      } else {
        day = i - firstDayOfWeek;
        if (lastMonthDay < day) {
          day -= lastMonthDay;
          days.push(new Date(nextMonth.getFullYear(), nextMonth.getMonth(), day));
        } else {
          days.push(new Date(currentYearMonth.getFullYear(), currentYearMonth.getMonth(), day));
        }
      }
    }
  }
  const today = new Date();
  let rowsItems = [],
    rowValue = 0,
    rowlen = calenderRows;
  while (++rowValue <= rowlen) rowsItems.push(rowValue);
  const onClickDatePickerDiv = () => {
    setCurrentYearMonth(new Date(currentYearMonth.setMonth(currentYearMonth.getMonth() - 1)));
  };
  const onClickDatePickerSubDiv = () => {
    setCurrentYearMonth(new Date(currentYearMonth.setMonth(currentYearMonth.getMonth() + 1)));
  };
  const setMonthSelector = () => {
    setCurrentSelector(_interface.DatePickerSelectorEnum.MONTH);
  };
  const setYearSelector = () => {
    setCurrentSelector(_interface.DatePickerSelectorEnum.YEAR);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_HorizontalStack.default, {
      justifyContent: "space-between",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        onClick: onClickDatePickerDiv,
        children: prevMonthButtonView ?? (_SvgIcon || (_SvgIcon = /*#__PURE__*/(0, _jsxRuntime.jsx)(_SvgIcon3.default, {
          className: 'mun-date-picker__icon',
          url: _images.DatePickerLeftIcon
        })))
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledMonthSelector.StyledMonthTypography, {
          color: monthYearColor,
          variant: "subheadline",
          as: 'span',
          onClick: setMonthSelector,
          hoverColor: hoverMonthYearTextColor ?? theme.color.primary,
          theme: theme,
          fontFamily: monthYearFontFamily,
          fontStyle: monthYearFontStyle,
          fontWeight: `${monthYearFontWeight}`,
          fontSize: `${monthYearFontSize}px`,
          textTransformation: monthYearTransformation,
          textDecoration: monthYearDecoration,
          hoverBgColor: hoverMonthYearBgColor,
          children: monthNames[currentYearMonth.getMonth()]
        }), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledMonthSelector.StyledMonthTypography, {
          color: monthYearColor,
          as: 'span',
          onClick: setYearSelector,
          hoverColor: hoverMonthYearTextColor ?? theme.color.primary,
          theme: theme,
          fontFamily: monthYearFontFamily,
          fontStyle: monthYearFontStyle,
          fontWeight: `${monthYearFontWeight}`,
          fontSize: `${monthYearFontSize}px`,
          textTransformation: monthYearTransformation,
          textDecoration: monthYearDecoration,
          hoverBgColor: hoverMonthYearBgColor,
          children: currentYearMonth.getFullYear()
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        onClick: onClickDatePickerSubDiv,
        children: nextMonthButtonView ?? (_SvgIcon2 || (_SvgIcon2 = /*#__PURE__*/(0, _jsxRuntime.jsx)(_SvgIcon3.default, {
          className: 'mun-date-picker__icon',
          url: _images.DatePickerRightIcon
        })))
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_VerticalStack.default, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_HorizontalStack.default, {
        justifyContent: "space-between",
        children: weekdayNames.map((weekday, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_CenterStack.default, {
          height: dateWeekHeight,
          width: dateWeekWidth,
          margin: dateWeekMargin,
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledMonthSelector.StyledWeekTypography, {
            color: weekdaysColor,
            variant: "caption",
            fontFamily: weekFontFamily,
            fontStyle: weekFontStyle,
            fontWeight: `${weekFontWeight}`,
            fontSize: `${weekFontSize}px`,
            textTransformation: weekTransformation,
            textDecoration: weekDecoration,
            hoverTextColor: hoverWeekTextColor,
            hoverBgColor: hoverWeekBgColor,
            lineHeight: `${weekLineHeight}px`,
            children: weekday
          })
        }, index))
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_VerticalStack.default, {
        children: rowsItems.map((_r, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_DatePickerHorizontalStack.DatePickerHorizontalStack, {
          sDate: sDate,
          eDate: eDate
          // @ts-ignore
          ,
          setStartDate: setStartDate,
          setEndDate: handleSetDate,
          setSelectedDate: setSelectedDate,
          daysColor: daysColor,
          disabledDaysColor: disabledDaysColor,
          mode: mode,
          selectedDate: selectedDate,
          onDateChange: onDateChange,
          onChangeDatesHande: onChangeDatesHande,
          onChangeStartEndDateHandle: onChangeStartEndDateHandle,
          days: days,
          index: index,
          daysPerWeek: daysPerWeek,
          currentYearMonth: currentYearMonth,
          maxDate: maxDate,
          minDate: minDate,
          today: today,
          selDate: selDate,
          selDates: selDates,
          weekdayNames: weekdayNames,
          borderRadius: borderRadius,
          calenderBoxShadow: calenderBoxShadow,
          calenderBorderWidth: calenderBorderWidth,
          calenderBorderStyle: calenderBorderStyle,
          calenderBorderColor: calenderBorderColor,
          dateWeekHeight: dateWeekHeight,
          dateWeekWidth: dateWeekWidth,
          dateWeekMargin: dateWeekMargin,
          dateBgColor: dateBgColor,
          hoverDateBgColor: hoverDateBgColor,
          dateBorderRadius: dateBorderRadius,
          dateBorderWidth: dateBorderWidth,
          dateBorderStyle: dateBorderStyle,
          dateBorderColor: dateBorderColor,
          dateBoxShadow: dateBoxShadow,
          dateFontFamily: dateFontFamily,
          dateFontStyle: dateFontStyle,
          dateFontWeight: dateFontWeight,
          dateFontSize: dateFontSize,
          dateTransformation: dateTransformation,
          dateDecoration: dateDecoration,
          hoverDateTextColor: hoverDateTextColor,
          dateLineHeight: dateLineHeight,
          disabledDateBgColor: disabledDateBgColor,
          disabledDateBorderRadius: disabledDateBorderRadius,
          disabledDateBorderWidth: disabledDateBorderWidth,
          disabledDateBorderStyle: disabledDateBorderStyle,
          disabledDateBorderColor: disabledDateBorderColor,
          disabledDateBoxShadow: disabledDateBoxShadow,
          disabledDateFontFamily: disabledDateFontFamily,
          disabledDateFontStyle: disabledDateFontStyle,
          disabledDateFontWeight: disabledDateFontWeight,
          disabledDateFontSize: disabledDateFontSize,
          disabledDateTransformation: disabledDateTransformation,
          disabledDateDecoration: disabledDateDecoration,
          disabledDateTextColor: disabledDateTextColor
        }, Math.random()))
      })]
    })]
  });
};
exports.DateSelector = DateSelector;
var _default = exports.default = DateSelector;